import { get, post } from '../tools/http';
import { copy, comparer } from '../tools/comparer';
import { isoStringToYYYYMMDD } from '../tools/moment-date';
import Vue from 'vue';

export default {
    state: {
        docs: [],
        docsServer: [],
    },
    mutations: {
        setDocs: (state, docs) => {
            state.docs = docs;
            state.docsServer = copy(docs);
        },
        setDoc: (state, Docs) => {
            state.docs.push(Docs);
            state.docsServer.push(copy(Docs));
        },
        updateDoc: (state, doc) => {
            let docFinderIndex = state.docs.findIndex((prevDoc) => {
                return prevDoc.id === doc.id;
            });
            if (docFinderIndex > -1) {
                Vue.set(state.docs, docFinderIndex, {
                    ...state.docs[docFinderIndex],
                    ...doc,
                });
                Vue.set(state.docsServer, docFinderIndex, {
                    ...state.docsServer[docFinderIndex],
                    ...copy(doc),
                });
            }
        },
        removeDoc: (state, index) => {
            state.docs = state.docs.filter((doc, i) => i !== index);
            state.docsServer = copy(state.docs);
        },
    },
    actions: {
        loadDocs: async (ctx) => {
            let docs = await get('profile', 'docs');
            ctx.commit('setDocs', docs.docs.map((doc)=>{
                return {
                    ...doc,
                    dateOfIssue: isoStringToYYYYMMDD(doc['dateOfIssue']),
                };
            }));
        },
        addDocs: (ctx) => {
            const newDoc = {
                "creating": true,
                "series": "",
                "num" : "",
                "dateOfIssue" : null,
                "issuer": "",
                "issuerCode": "",
                "foreignDocTypeId": null,
                "files": [],
            };
            ctx.commit('setDocs', [...ctx.state.docs, newDoc]);
        },
        saveDoc: async (ctx, {doc, index}) => {
            if (doc.creating) {
                await ctx.dispatch('createDoc', { doc, index });
            } else {
                await ctx.dispatch('updateDoc', { doc, index });
            }
        },
        createDoc: async (ctx, { doc, index }) => {
            const postParams = [
                'profile',
                'doc/create',
                doc,
                true,
            ];
            const newDoc = await post(...postParams);
            if (newDoc === null) {
                throw new Error('Ошибка');
            }
            ctx.commit('setDocs', ctx.state.docs.map((doc, i) => {
                if (i === index) {
                    doc.id = newDoc.id;
                    doc.creating = undefined;
                }
                return doc;
            }));
        },
        updateDoc: async (ctx, {doc, index}) => {
            const diff = comparer(ctx.state.docsServer[index], doc);
            if (Object.keys(diff).length > 0) {
                const postParams = [
                    'profile',
                    'doc/update',
                    {...diff, id: doc.id},
                    true,
                ];
                const resp = await post(...postParams);
                if (resp === null) {
                    throw new Error('Ошибка');
                }
                ctx.commit('updateDoc', { ...diff, id: doc.id });
            }
        },
        removeDoc: async (ctx, {doc, index}) => {
            if (doc.id) {
                const getParams = [
                    'profile',
                    `doc/${doc.id}/remove`,
                ];
                await get(...getParams);
            }
            ctx.commit('removeDoc', index);
        },
    },
    getters: {
        getDocs: state => state.docs,
    },
};
